function shipmentsSingleBookingDetailsController() {
  const vm = this;

  /** Initial values for the controller */
  vm.orderByField = "Description";
  vm.reverse = false;
}

export default shipmentsSingleBookingDetailsController;
